module.exports = __webpack_public_path__ + "img/BackgroundImage_03_Trimmed.7156e91f.png";